import template from './template.html';
import controller from './controller';

const controllerAs = 'authorInfoCtrl';
const bindings = {
  ngModel: '=',
  vendors: '=',
  payees: '=',
  categoryData: '=',
  deliveryMethodData: '=',
  course: '=',
  adminReviews: '=',
  profile: '=',
  sponsors: '=',
  regulators: '='
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/author/info/index.js